// extracted by mini-css-extract-plugin
export default {"message":"ModalError-message-HZzN5 ErrorBoundaryError-message-YnXdu","details":"ModalError-details-bpGAW ErrorBoundaryError-details-c3TVO"};